import { askDate, type NextServiceAnchor, type NextServiceAskRules } from '../core/ask.js';
import type { BusNextServicesBlock } from '@voll-intelligence/genui-contract';

/** O pós-passagem (frame 09) ancora na CIDADE da rodoviária de chegada. Sem
 *  ela ou sem o dia da chegada, o pedido é «para essa viagem». */
export const BUS_ASK_RULES: NextServiceAskRules = {
  hotel: {
    window: {
      range: 'bus.nextServices.ask.hotelRange',
      open: 'bus.nextServices.ask.hotelOpen',
      trip: 'bus.nextServices.ask.hotelTrip',
    },
  },
  car: {
    window: {
      range: 'bus.nextServices.ask.carRange',
      open: 'bus.nextServices.ask.carOpen',
      trip: 'bus.nextServices.ask.carTrip',
    },
  },
  insurance: { fixed: 'bus.nextServices.ask.insurance' },
  flight: { fixed: 'bus.nextServices.ask.flight' },
  seat: { fixed: 'bus.nextServices.ask.seat' },
  train: { fixed: 'bus.nextServices.ask.train' },
  bus: { fixed: 'bus.nextServices.ask.bus' },
  transfer_to_airport: { fixed: 'bus.nextServices.ask.transferToAirport' },
  transfer_airport_hotel: { fixed: 'bus.nextServices.ask.transferAirportHotel' },
  transfer_to_hotel: { fixed: 'bus.nextServices.ask.transferToHotel' },
};

/** A cidade do nome de uma parada do ônibus. O dado do ônibus não tem cidade, só
 *  o nome da rodoviária, que vem como "Cidade, UF", "Cidade, UF - Rodoviária" ou
 *  "Cidade - Rodoviária": vale a parte antes do " - " (o hífen SEM espaço fica —
 *  "Embu-Guaçu" é uma cidade). Com o nome da rodoviária, a busca de hotel ou de
 *  carro não acha o lugar. */
function cityOfStop(stopName: string | undefined): string | null {
  const city = stopName?.split(' - ')[0]?.trim();
  return city ? city : null;
}

/** Onde e quando a pessoa chega (a ida) e quando volta (a volta, se houver). */
export function busAnchor(block: BusNextServicesBlock, locale: string): NextServiceAnchor {
  const legs = block.items.flatMap((item) => (item.productType === 'bus' ? [item.detail] : []));
  const outbound = legs.find((leg) => leg.leg !== 'return') ?? legs[0];
  const back = legs.find((leg) => leg.leg === 'return');
  return {
    param: 'city',
    value: cityOfStop(outbound?.arrival.stopName),
    from: askDate(outbound?.arrival.dateTime, locale),
    to: askDate(back?.departure.dateTime, locale),
  };
}
